import { joinStateParts } from 'Modules/core/redux';

import { certificates } from './certificates';
import { cryptoprofiles } from './cryptoprofiles';


export const state = joinStateParts({
    certificates,
    cryptoprofiles,
});
